// extracted by mini-css-extract-plugin
module.exports = {"avatar":"_1uSF7QQXkBZQXx7Ngnwirq"};